export const fieldsEditProgram = [
  {    
    title: 'Titulo*',
    field: 'titulo',
    type: 'text',
    boolType: false,
    component: 'text',
    placeholder: '',
  },
  {    
    title: 'Cidade',
    field: 'cidade',
    boolType: false,
    component: 'select',
    disable: true,
  },
  {    
    title: 'Diretriz*',
    field: 'idDiretrizes',
    type: 'select',
    boolType: false,
    component: 'select',
  },
  {    
    title: 'Ativo*',
    field: 'active',
    type: 'select',
    boolType: true,
    component: 'select',
  },
];